import React, { useState, FormEvent, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, Classes, MenuItem, Alert, Spinner } from "@blueprintjs/core";

import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { Account, Currency, NumData, Environment, Payable, PayableItem, Vendor } from './Types'


interface PayableViewProps {
    svc: AxiosInstance,
    currentEnv: Environment,
    ap: Payable,
    baseUrl?: string,
    token?: string | null,
    onNew?: () => void,
    onEdit?: () => void,
    onCopy?: () => void,
    onDelete?: (ap: Payable) => void,
}

function PayableView({ svc, currentEnv, ap = {} as Payable, baseUrl = "", token = "", onNew = () => {}, onEdit = () => { }, onCopy = () => { }, onDelete = () => { } }: PayableViewProps) {
    const { t, i18n } = useTranslation();
    const [isOpenDelete, setIsOpenDelete] = useState(false)

    if (!("voucherCode" in ap)) return null

    let totalDr = ap.dr, totalCr = ap.cr
    for (const item of ap.items) {
        totalDr += item.dr
        totalCr += item.cr
    }

    return (
        <div>
            {/*
            <Dialog icon="help" isOpen={isOpenDelete} canEscapeKeyClose={true} canOutsideClickClose={true} title="AC3x" onClose={() => setIsOpenDelete(false)}>
                <div className="DialogBody">
                    <div className="Spacing-V-16" />
                    <p>Delete voucher {ap.voucherCode}?</p>
                    <div className="Row-4">
                        <Button className="Col-3-1" icon="cross" onClick={() => setIsOpenDelete(false)}>No</Button>
                        <Button className="Col-4-1" icon="tick" intent="danger" onClick={() => {onDelete(ap); setIsOpenDelete(false)}}>DELETE</Button>
                    </div>
                </div>
            </Dialog>
            */}
            <Alert icon="trash" intent="danger" confirmButtonText={t('button_delete')} isOpen={isOpenDelete} onConfirm={() => {onDelete(ap); setIsOpenDelete(false)}} onCancel={() => setIsOpenDelete(false)} cancelButtonText={t('button_no')} canEscapeKeyCancel={true} canOutsideClickCancel={true}>
                <p>{t('confirm_delete_ap', {ap})}</p>
            </Alert>
            <div className="Row">
                <Button className="Col-1-1" icon="add" onClick={() => onNew()}>{t('new')}</Button>
                <Button className="Col-2-1" icon="edit" onClick={() => onEdit()}>{t('edit')}</Button>
                <Button className="Col-3-1" icon="duplicate" onClick={() => onCopy()}>{t('make_copy')}</Button>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('journal')}>
                    <InputGroup readOnly value={ap.journalCode} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('voucher')}>
                    <InputGroup readOnly value={ap.voucherCode} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('reference')}>
                    <InputGroup readOnly value={ap.reference} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('date')}>
                    <InputGroup readOnly value={ap.txDate} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('vendor_code')}>
                    <InputGroup readOnly value={ap.vendCode} />
                </FormGroup>
                <FormGroup className="Col-2-2" label={t('vendor_name')}>
                    <InputGroup readOnly value={ap.vendName} />
                </FormGroup>
            </div>
            <div className="Row">
                {/*
                <FormGroup className="Col-1-1" label={t('tx_type')}>
                    <InputGroup readOnly value={ap.txType} />
                </FormGroup>
                */}
                <FormGroup className="Col-1-1" label={t('invoice_no')}>
                    <InputGroup readOnly value={ap.invNo} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('invoice_date')}>
                    <InputGroup readOnly value={ap.invDate} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('due_date')}>
                    <InputGroup readOnly value={ap.dueDate} />
                </FormGroup>
            </div>
            <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-ACCode">{t('account')}</th>
                    <th className="TCol-ACName">{t('account_name')}</th>
                    <th className="TCol-Desc">{t('description')}</th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('dr')}</div></th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('cr')}</div></th>
                </tr>
            </thead>
            <tbody>
                <tr key={0}>
                        <td className="TCol-ACCode">{ap.acCode}</td>
                        <td className="TCol-ACName">{ap.acName}</td>
                        <td className="TCol-Desc">{ap.description}</td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(ap.dr)}</div></td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(ap.cr)}</div></td>
                    </tr>
                {ap.items.map((item, i) =>
                    <tr key={i+1}>
                        <td className="TCol-ACCode">{item.acCode}</td>
                        <td className="TCol-ACName">{item.acName}</td>
                        <td className="TCol-Desc">{item.description}</td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(item.dr)}</div></td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(item.cr)}</div></td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                <td className="TCol-ACCode"></td>
                <td className="TCol-ACName"></td>
                <td className="TCol-Desc"></td>
                <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalDr)}</b></div></td>
                <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalCr)}</b></div></td>
                </tr>
            </tfoot>
            </HTMLTable>
            <div className="Spacing-V-16" />
            <div className="Row">
                <Button className="Col-1-1" icon="trash" onClick={() => setIsOpenDelete(!isOpenDelete)}>{t('delete')}</Button>
            </div>
        </div>
    )
}

interface PayableEditProps {
    svc: AxiosInstance,
    currentEnv: Environment,
    ap?: Payable,
    ccyList?: Currency[],
    acList?: Account[],
    numList?: NumData[],
    isNew?: boolean,
    onSave: (ap: Payable, saveAndNew: boolean) => Promise<boolean>,
    onCancel: () => void,
}

function PayableEdit({ svc, currentEnv, ap = {} as Payable, ccyList = [] as Currency[], acList = [] as Account[], numList = [] as NumData[], isNew = false, onSave, onCancel }: PayableEditProps) {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue, getValues } = useForm<Payable>()

    const defaultItems = "voucherCode" in ap ? ap.items : [{} as PayableItem]
    const [items, setItems] = useState(defaultItems)
    const [vendList, setVendList] = useState([] as Vendor[])
    const defaultAcAp = "voucherCode" in ap ? {acCode: ap.acCode, acName1: ap.acName} as Account : {}
    const [acAp, setAcAp] = useState(defaultAcAp as Account)
    const defaultVend = "voucherCode" in ap ? {vendCode: ap.vendCode, vendName: ap.vendName} as Vendor : {}
    const [currentVend, setCurrentVend] = useState(defaultVend as Vendor)
    const [totalDr, setTotalDr] = useState(0)
    const [totalCr, setTotalCr] = useState(0)

    const onFormChange = () => recalcTotals()
    const recalcTotals = () => {
        let sumDr = 0, sumCr = 0
        sumDr += utils.StringToNum(getValues(`dr`))
        sumCr += utils.StringToNum(getValues(`cr`))
        for (let i = 0; i < items.length; i++) {
            sumDr += utils.StringToNum(getValues(`items[${i}].dr`))
            sumCr += utils.StringToNum(getValues(`items[${i}].cr`))
        }
        setTotalDr(sumDr)
        setTotalCr(sumCr)
    }

    const refreshVendList = async () => {
        if ("envId" in currentEnv) {
            const res = await svc.post('/vendorlist');
            //console.log("refreshVendList", res.data.data)
            setVendList(res.data.data)
        }
    }

    useEffect(() => {
        console.log("useEffect [vendList]")
    }, [vendList])

    useEffect(() => {
        console.log("useEffect [currentEnv]")
        refreshVendList()
    }, [currentEnv])

    useEffect(() => {
        // Call reset to set default values if ap is passed
        //console.log("useEffect ap, reset, setValue, isNew")
        console.log("useEffect []")
        if ("voucherCode" in ap) {
            if (isNew) {
                // default values for new/copied record
                reset({...ap, ...{voucherCode: "", txDate: utils.formatDate(new Date()), invDate: utils.formatDate(new Date()), dueDate: utils.formatDate(new Date()), invNo: "", reference: ""}})
            } else {
                reset(ap)
            }
        }
        recalcTotals()
        /*
        if (isNew) {
            setValue("txType", "I")
            setValue("txDate", utils.formatDate(new Date()))
            setValue("invDate", utils.formatDate(new Date()))
            setValue("dueDate", utils.formatDate(new Date()))
        }
        */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //}, [ap, reset, setValue, isNew])

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        console.log("useEffect [register]")
        register({ name: "txType" })
        //register({ name: "ccyCode" })
        //register({ name: "journalCode" })
        register({ name: "vendCode" })
        register({ name: "acCode" })
        items.map((item, i) => {register({ name: `items[${i}].acCode`});return null})
        console.log("register fields")

        if (isNew) {
            console.log("set default values")
            setValue("txType", "I")
            setValue("txDate", utils.formatDate(new Date()))
            setValue("invDate", utils.formatDate(new Date()))
            setValue("dueDate", utils.formatDate(new Date()))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [register])

    if (!isNew && !("voucherCode" in ap)) return null

    //const onSubmitAndNew = (data: Payable) => preSave(data, true)
    //const onSubmit = (data: Payable) => preSave(data, false)
    //const preSave = async (data: Payable, saveAndNew: boolean = false) => {
    const onSubmit = async (data: Payable) => {
        //data.dr = 0
        //data.cr = 0
        console.log(Object.assign(data))
        for (let i = data.items.length-1; i >= 0; i--) {
            //console.log(i, data.items[i] && data.items[i].acCode)
            if (data.items[i] === undefined ||
                data.items[i].acCode === "" ||
                (data.items[i].acCode !== "C" && (data.items[i].dr - data.items[i].cr) === 0) ||
                (data.items[i].acCode === "C" && data.items[i].description === ""  && (data.items[i].dr - data.items[i].cr) === 0)) {
                //console.log("deleting", i)
                data.items.splice(i, 1)
            } else {
                //data.dr += Number(data.items[i].dr)
                //data.cr += Number(data.items[i].cr)
            }
        }
        //console.log("onsubmit called", data)
        let saveAndNew = isNew
        if (await onSave(data, saveAndNew) && saveAndNew) {
            //console.log("saveAndNew resetting form")
            setItems([{} as PayableItem])
            setCurrentVend({} as Vendor)
            setAcAp({} as Account)
            reset({
                journalCode: data.journalCode,
                voucherCode: "",
                txDate: utils.formatDate(new Date()),
                invDate: utils.formatDate(new Date()),
                dueDate: utils.formatDate(new Date()),
                invNo: "",
                acCode: "",
                acName: "",
                description: "",
                dr: 0,
                cr: 0,
                reference: "",
                items: [{acName: ""}]
            })
            recalcTotals()
            document.getElementsByName(`voucherCode`)[0].focus()
        }
    }

    const onAdd = () => {
        register({ name: `items[${items.length}].acCode`})
        console.log("register", { name: `items[${items.length}].acCode`})
        setItems(items.concat({} as PayableItem))
    }

    const acRenderer: ItemRenderer<Account> = (ac, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${ac.acCode} ${ac.acName1.length > 0 || ac.acName2.length > 0 ? '-' : ''} ${ac.acName1+ac.acName2}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={ac.acCode}
                key={ac.acCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const acPredicate: ItemPredicate<Account> = (query, ac, _index, exactMatch) => {
        const normalizedText = `${ac.acCode} - ${ac.acName1+ac.acName2}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const acValueRenderer = (ac: Account) => {
        return ac.acCode
    }

    const vendRenderer: ItemRenderer<Vendor> = (vend, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${vend.vendCode} - ${vend.vendName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={vend.vendCode}
                key={vend.vendCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const vendPredicate: ItemPredicate<Vendor> = (query, vend, _index, exactMatch) => {
        const normalizedText = `${vend.vendCode} - ${vend.vendName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const vendValueRenderer = (vend: Vendor) => {
        return vend.vendCode
    }

    const createVendDataFromQuery = (query: string) => {
        return {vendCode: query.toUpperCase().slice(0, 10), vendName: query} as Vendor
    }

    const createVendDataRenderer = (
        query: string,
        active: boolean,
        handleClick: React.MouseEventHandler<HTMLElement>,
    ) => (
        <MenuItem
            icon="add"
            text={`Create "${query}"`}
            active={active}
            onClick={handleClick}
            shouldDismissPopover={false}
        />
    );

    const numRenderer: ItemRenderer<NumData> = (num, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${num.group}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={num.group}
                key={num.group}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const numPredicate: ItemPredicate<NumData> = (query, num, _index, exactMatch) => {
        const normalizedText = `${num.group}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const numValueRenderer = (num: NumData) => {
        return num.group
    }

    const createNumDataFromQuery = (query: string) => {
        return {type: "J", group: query.toUpperCase(), last: 0} as NumData
    }

    const createNumDataRenderer = (
        query: string,
        active: boolean,
        handleClick: React.MouseEventHandler<HTMLElement>,
    ) => (
        <MenuItem
            icon="add"
            text={`Create "${query}"`}
            active={active}
            onClick={handleClick}
            shouldDismissPopover={false}
        />
    );

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmitAndNew)()
            handleSubmit(onSubmit)()
        }
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey} onChange={onFormChange}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>{t('cancel')}</Button>
                {/*!isNew && <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>{t('save')}</Button>*/}
                {/*isNew && <Button className="Col-2-1" icon="add" onClick={handleSubmit(onSubmitAndNew)}>{t('save')}</Button>*/}
                <Button className="Col-2-1" icon={isNew?"add":"tick"} onClick={handleSubmit(onSubmit)}>{t('save')}</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ap)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('journal')} labelFor="inputJournalCode">
                    {/*
                    {isNew && <Suggest
                        inputProps={{ placeholder: "" }}
                        items={numList}
                        itemRenderer={numRenderer}
                        itemPredicate={numPredicate}
                        inputValueRenderer={numValueRenderer}
                        createNewItemFromQuery={createNumDataFromQuery}
                        createNewItemRenderer={createNumDataRenderer}
                        resetOnClose={true}
                        onItemSelect={(num) => {
                            setValue(`journalCode`, num.group)
                        }}
                    />}
                    {!isNew && <InputGroup readOnly defaultValue={ap.journalCode} />}
                    */}
                    <InputGroup readOnly name="journalCode" defaultValue="AP" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('voucher')} labelFor="inputPayableCode">
                    <InputGroup readOnly={!isNew} id="inputPayableCode" name="voucherCode" placeholder={t('auto_generated')} defaultValue={ap.voucherCode} inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('reference')} labelFor="inputReference">
                    <InputGroup id="inputReference" name="reference" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('date')} labelFor="inputTxDate">
                    <InputGroup id="inputTxDate" name="txDate" type="date" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('vendor_code')} labelFor="inputVendCode">
                    {/*<InputGroup id="inputVendCode" name="vendCode" inputRef={register} />*/}
                    <Suggest
                        inputProps={{ placeholder: "" }}
                        //defaultSelectedItem={{vendCode: ap.vendCode, vendName: ap.vendName} as Vendor}
                        selectedItem={currentVend}
                        items={vendList}
                        itemRenderer={vendRenderer}
                        itemPredicate={vendPredicate}
                        inputValueRenderer={vendValueRenderer}
                        createNewItemFromQuery={createVendDataFromQuery}
                        createNewItemRenderer={createVendDataRenderer}
                        resetOnClose={true}
                        onItemSelect={(vend) => {
                            if (!vendList.find((v) => v.vendCode === vend.vendCode)) {
                                setVendList(vendList.concat(vend))
                            }
                            setCurrentVend(vend)
                            setValue('vendCode', vend.vendCode)
                            setValue('vendName', vend.vendName)
                            setValue('description', vend.vendName.slice(0, 100-1-getValues('invNo').length )+"-"+getValues('invNo'))
                            //setValue('acCode', )
                            console.log(vend, currentEnv.acPayable)
                            let ac = acList.find((ac) => ac.acCode === vend.acPayable)
                            if (!ac) ac = acList.find((ac) => ac.acCode === currentEnv.acPayable)
                            if (ac) {
                                setAcAp(ac)
                                setValue('acCode', ac.acCode)
                                setValue(`acName`, ac.acName1+ac.acName2)
                            }
                            document.getElementsByName(`invNo`)[0].focus()
                        }}
                    />
                </FormGroup>
                <FormGroup className="Col-2-2" label={t('vendor_name')} labelFor="inputVendName">
                    <InputGroup readOnly id="inputVendName" name="vendName" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                {/*
                <FormGroup className="Col-1-1" label={t('tx_type')} labelFor="inputTxType">
                    <InputGroup id="inputTxType" name="txType" inputRef={register} />
                </FormGroup>
                */}
                <FormGroup className="Col-1-1" label={t('invoice_no')} labelFor="inputInvoiceNo">
                    <InputGroup id="inputInvoiceNo" name="invNo" inputRef={register} onChange={() => {setValue('description', getValues('vendName').slice(0, 100-1-getValues('invNo').length )+"-"+getValues('invNo'))}} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('invoice_date')} labelFor="inputInvoiceDate">
                    <InputGroup id="inputInvoiceDate" name="invDate" type="date" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('due_date')} labelFor="inputDueDate">
                    <InputGroup id="inputDueDate" name="dueDate" type="date" inputRef={register} />
                </FormGroup>
                <Button className="Col-4-1 Button-LabeledFormGroup" icon="add" onClick={onAdd}>{t('add_entry')}</Button>
            </div>
            <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">{t('account')}</th>
                <th className="TCol-ACName">{t('account_name')}</th>
                <th className="TCol-Desc">{t('description')}</th>
                <th className="TCol-ACBalance"><div className="Align-R">{t('dr')}</div></th>
                <th className="TCol-ACBalance"><div className="Align-R">{t('cr')}</div></th>
            </thead>
            <tbody>
                    <tr>
                        {/*<td className="TCol-ACCode"><InputGroup id="inputAcCode" name={`items[${i}].acCode`} inputRef={register} /></td>*/}
                        <td className="TCol-ACCode">
                            <Suggest
                                inputProps={{ placeholder: "" }}
                                //defaultSelectedItem={acList.find((ac) => ac.acCode === ap.acCode)}
                                selectedItem={acAp}
                                items={acList}
                                itemRenderer={acRenderer}
                                itemPredicate={acPredicate}
                                inputValueRenderer={acValueRenderer}
                                resetOnClose={true}
                                onItemSelect={(ac) => {
                                    setAcAp(ac)
                                    setValue(`acCode`, ac.acCode)
                                    //console.log("setValue", `items[${i}].acCode`, ac.acCode)
                                    setValue(`acName`, ac.acName1+ac.acName2)
                                    //console.log("newItems", newItems)
                                    document.getElementsByName(`description`)[1].focus()
                                }}
                            />
                        </td>
                        <td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`acName`} value={ap.acName} inputRef={register} /></td>
                        {/*<td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`ap.acName`} inputRef={register} /></td>*/}
                        <td className="TCol-Desc">
                            <InputGroup id="inputDesc" name="description" defaultValue={ap.description} inputRef={register} />
                        </td>
                        <td className="TCol-ACBalance"><InputGroup id="inputDr" name="dr" defaultValue={utils.numToString(ap.dr)} type="number" inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputCr" name="cr" defaultValue={utils.numToString(ap.cr)} type="number" inputRef={register} /></td>
                    </tr>
                {items.map((item, i) =>
                    <tr>
                        {/*<td className="TCol-ACCode"><InputGroup id="inputAcCode" name={`items[${i}].acCode`} inputRef={register} /></td>*/}
                        <td className="TCol-ACCode">
                            <Suggest
                                inputProps={{ placeholder: "" }}
                                //defaultSelectedItem={acList.find((ac) => ac.acCode === item.acCode)}
                                selectedItem={{acCode: item.acCode} as Account}
                                items={acList}
                                itemRenderer={acRenderer}
                                itemPredicate={acPredicate}
                                inputValueRenderer={acValueRenderer}
                                resetOnClose={true}
                                onItemSelect={(ac) => {
                                    setValue(`items[${i}].acCode`, ac.acCode)
                                    //console.log("setValue", `items[${i}].acCode`, ac.acCode)
                                    let newItems = Array.from(items)
                                    newItems[i].acCode = ac.acCode
                                    newItems[i].acName = ac.acName1+ac.acName2
                                    //console.log("newItems", newItems)
                                    setItems(newItems)
                                    document.getElementsByName(`items[${i}].description`)[0].focus()
                                }}
                            />
                        </td>
                        <td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`items[${i}].acName`} value={items[i].acName} inputRef={register} /></td>
                        {/*<td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`items[${i}].acName`} inputRef={register} /></td>*/}
                        <td className="TCol-Desc">
                            <InputGroup id="inputDesc" name={`items[${i}].description`} inputRef={register}
                                onKeyDown={
                                    (e: React.KeyboardEvent<HTMLInputElement>) => {
                                        // ctrl + shift + " (Excel copy above cell)
                                        if (e.ctrlKey && e.shiftKey && e.keyCode === 222) {
                                            e.preventDefault()
                                            setValue(`items[${i}].description`, getValues(`items[${i-1}].description`))
                                        }
                                    }
                                }
                                rightElement={
                                    i > 0 ?
                                        <Button icon="chevron-up" minimal onClick={() => {setValue(`items[${i}].description`, getValues(`items[${i-1}].description`))}}></Button> :
                                        <Button icon="chevron-up" minimal onClick={() => {setValue(`items[${i}].description`, getValues(`description`))}}></Button>
                                }
                            />
                        </td>
                        <td className="TCol-ACBalance"><InputGroup id="inputDr" name={`items[${i}].dr`} type="number" inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputCr" name={`items[${i}].cr`} type="number" inputRef={register} /></td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                    <td className="TCol-ACCode"></td>
                    <td className="TCol-ACName"></td>
                    <td className="TCol-Desc"></td>
                    <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalDr)}</b></div></td>
                    <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalCr)}</b></div></td>
                </tr>
            </tfoot>
            </HTMLTable>
        </form>
    )
}

interface PayableMainProps {
    svc: AxiosInstance,
    currentEnv: Environment,
}

/*
const toaster = Toaster.create({
    position: Position.TOP,
})
*/

function PayableMain({ svc, currentEnv = {} as Environment }: PayableMainProps) {
    let { tabId: defaultTabId = "list", journalCode: defaultJournalCode, voucherCode: defaultPayableCode }: { tabId: string, journalCode: string, voucherCode: string } = useParams()
    const { t, i18n } = useTranslation();
    const history = useHistory()

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([] as Payable[])

    const [ccyList, setCcyList] = useState([] as Currency[])
    const [acList, setAcList] = useState([] as Account[])
    const [numList, setNumList] = useState([] as NumData[])

    const [searchKey, setSearchKey] = useState("journalCode")
    const [searchValue, setSearchValue] = useState("AP")
    const [searchValue2, setSearchValue2] = useState("")

    const [showFilters, setShowFilters] = useState(true)

    let date = new Date(), y = date.getFullYear(), m = date.getMonth()
    const [searchFrom, setSearchFrom] = useState(utils.formatDate(new Date(y, m-1, 1)))
    const [searchTo, setSearchTo] = useState(utils.formatDate(date))

    const [searchReference, setSearchReference] = useState("")
    const [searchVendor, setSearchVendor] = useState("")
    const [searchParty, setSearchParty] = useState("")
    const [searchDesc, setSearchDesc] = useState("")

    const [searchLimit, setSearchLimit] = useState(0)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [lastTabId, setLastTabId] = useState("list")
    const [currentAP, setCurrentAP] = useState({} as Payable)

    const [currentMode, setCurrentMode] = useState("show")

    useEffect(() => {
        console.log("useEffect [defaultJournalCode, defaultPayableCode]")
        if ("envId" in currentEnv && defaultJournalCode && defaultPayableCode) {
            console.log("show", defaultJournalCode, defaultPayableCode);
            (async () => {
                try {
                    const res = await svc.post('/aplist',
                        {
                            by: "journalCode",
                            start: defaultJournalCode,
                            voucherCode: defaultPayableCode,
                            limit: 1,
                        });
        
                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentAP(res.data.data[0])
                    } else {
                        utils.showError(t('no_record'))
                    }
                    //changeTab("list")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            //console.log("not show", defaultJournalCode, defaultPayableCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultJournalCode, defaultPayableCode, svc, currentEnv])

    useEffect(() => {
        setSelectedTabId(defaultTabId)
    }, [defaultTabId])

    const changeTab = (tabId: string) => {
        history.push(`/payables/${tabId}`)
        setSelectedTabId(tabId)
    }

    /*
    useEffect(() => {
        setSearchFrom(utils.formatDate(new Date(currentEnv.startOfYear)))
        setSearchTo(utils.formatDateMin(new Date(), new Date(currentEnv.endOfYear)))
    }, [currentEnv])
    */

    const refreshNumList = async () => {
        const res = await svc.post('/numlist',
            {
                type: "J",
            });
        setNumList(res.data.data)
    }

    useEffect(() => {
        console.log("useEffect [svc, currentEnv]");
        (async () => {
            try {
                /*
                {
                    const res = await svc.post('/getdates',
                        {});
                    setSearchFrom(res.data.data.startOfYear)
                    setSearchTo(utils.formatDate(new Date()))
                }
                */
                if ("envId" in currentEnv) {
                    refreshNumList()
                    /*
                    const res = await svc.post('/numlist',
                        {
                            type: "J",
                        });
                    setNumList(res.data.data)
                    */
                }
                {
                    const res = await svc.post('/currencylist',
                        {
                            by: "ccyCode",
                            start: "",
                            limit: 0,
                            backward: false,
                            filters: {
                                ccyCode: "",
                            }
                        });
                    setCcyList(res.data.data)
                }
                if ("envId" in currentEnv) {
                    const res = await svc.post('/accountlist',
                        {
                            by: "acCode",
                            start: "",
                            limit: 0,
                            backward: false,
                            filters: {
                                isDetailOnly: true,
                            }
                        });

                    setAcList([{acCode: "C", acName1:"", acName2:""} as Account].concat(res.data.data))
                    //setAcList(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [svc, currentEnv])

    /*
    useEffect(() => {
        (async () => {
            try {
                const res = await svc.post('/currencylist',
                    {
                        by: "ccyCode",
                        start: "",
                        limit: 0,
                        backward: false,
                        filters: {
                            ccyCode: "",
                        }
                    });
                setCcyList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [svc])
    */

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        try {
            setIsLoading(true)
            const res = await svc.post('/aplist',
                {
                    by: searchKey,
                    start: searchKey === "journalCode" ? searchValue : searchVendor,
                    voucherCode: searchKey === "journalCode" ? searchValue2: "",
                    limit: searchLimit,
                    backward: searchBackward,
                    filters: {
                        from: searchFrom,
                        to: searchTo,
                        reference: searchReference,
                        vendor: searchParty,
                        desc: searchDesc,
                    }
                });

            setIsLoading(false)
            setData(res.data.data)
            if (res.data.data.length > 0) {
                setCurrentAP(res.data.data[0])
            } else {
                utils.showError(t('no_record'))
            }
            //changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    const editOnSave = async (ap: Payable) => {
        try {
            const res = await svc.post('/apupdate', ap)
            utils.showSuccess(t('saved', {key: res.data.data.journalCode+' '+res.data.data.voucherCode}))
            for (let i = 0; i < data.length; i++) {
                if (data[i].journalCode === res.data.data.journalCode && data[i].voucherCode === res.data.data.voucherCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAP(res.data.data)
            setCurrentMode("show")
            refreshNumList()
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const newOnSave = async (ap: Payable, newAndSave: boolean) => {
        try {
            const res = await svc.post('/apadd', ap)
            utils.showSuccess(t('saved', {key: res.data.data.journalCode+' '+res.data.data.voucherCode}))
            setCurrentAP(res.data.data)
            setData(data.concat(res.data.data))
            if (!newAndSave) setCurrentMode("show")
            refreshNumList()
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const viewOnDelete = async (ap: Payable) => {
        try {
            //console.log("deleting voucher:", ap)
            const res = await svc.post('/apdelete', ap)
            utils.showSuccess(t('deleted'))
            setData(data.filter(v => !(v.journalCode === res.data.journalCode && v.voucherCode === res.data.voucherCode)))
            setCurrentAP({} as Payable)
            changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    // currentMode = show
    let detail = <PayableView svc={svc} currentEnv={currentEnv} ap={currentAP} baseUrl={svc.defaults.baseURL} token={localStorage.getItem('token')} onNew={() => {setLastTabId(selectedTabId); setCurrentMode("new")}} onEdit={() => setCurrentMode("edit")} onCopy={() => setCurrentMode("copy")} onDelete={viewOnDelete}></PayableView>
    switch (currentMode) {
        case "edit":
            detail = <PayableEdit svc={svc} currentEnv={currentEnv} ap={currentAP} ccyList={ccyList} acList={acList} numList={numList} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></PayableEdit>
            break
        case "new":
            detail = <PayableEdit isNew svc={svc} currentEnv={currentEnv} ccyList={ccyList} acList={acList} numList={numList} onSave={newOnSave} onCancel={() => { setCurrentMode("show"); changeTab(lastTabId) }}></PayableEdit>
            break
        case "copy":
            detail = <PayableEdit isNew svc={svc} currentEnv={currentEnv} ap={currentAP} ccyList={ccyList} acList={acList} numList={numList} onSave={newOnSave} onCancel={() => { setCurrentMode("show") }}></PayableEdit>
            break
    }

    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setLastTabId(selectedTabId); setCurrentMode("new"); changeTab("detail") }}>{t('new')}</Button>
        </div>
        <div className="Spacing-V-16" />
        {isLoading && <Spinner></Spinner>}
        <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-Journal">{t('journal')}</th>
                    <th className="TCol-Voucher">{t('voucher')}</th>
                    <th className="TCol-Reference">{t('reference')}</th>
                    <th className="TCol-Date">{t('date')}</th>
                    <th className="TCol-PartyCode">{t('vendor_code')}</th>
                    <th className="TCol-InvoiceNo">{t('invoice_no')}</th>
                    <th className="TCol-Desc">{t('description')}</th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('amount')}</div></th>
                </tr>
            </thead>
            <tbody>
                {data.map((ap, i) =>
                    <tr key={i} onDoubleClick={() => { changeTab("detail") }}>
                        <td className="TCol-Journal" onClick={() => { setCurrentAP(ap) }}>{ap.journalCode}</td>
                        {/*<td className="TCol-Voucher" onClick={() => { setCurrentAP(ap) }}>{ap.voucherCode}</td>*/}
                        <td className="TCol-Voucher" onClick={() => { setCurrentAP(ap) }}><a target="_blank" href={`#/payables/detail/${ap.journalCode}/${ap.voucherCode}`}>{ap.voucherCode}</a></td>
                        <td className="TCol-Reference" onClick={() => { setCurrentAP(ap) }}>{ap.reference}</td>
                        <td className="TCol-Date" onClick={() => { setCurrentAP(ap) }}>{ap.txDate}</td>
                        <td className="TCol-PartyCode" onClick={() => { setCurrentAP(ap) }}>{ap.vendCode}</td>
                        <td className="TCol-InvoiceNo" onClick={() => { setCurrentAP(ap) }}>{ap.invNo}</td>
                        <td className="TCol-Desc" onClick={() => { setCurrentAP(ap) }}>{ap.description}</td>
                        <td className="TCol-ACBalance" onClick={() => { setCurrentAP(ap) }}><div className="Align-R">{utils.formatMoney(Math.abs(ap.dr - ap.cr))}</div></td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('payables')}</div>
            <div className="Spacing-V-16"></div>
            <form onSubmit={onSubmit}>
                <div className="Row">
                    <FormGroup className="Col-1-3" label={t('search')} labelFor="inputSearchValue">
                        <ControlGroup fill>
                            <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                <option value="journalCode">{t('journal')}</option>
                                <option value="vendCode">{t('vendor')}</option>
                            </HTMLSelect>
                            {searchKey === "journalCode" && <>
                            <InputGroup
                                id="inputSearchValue"
                                placeholder={t('journal')}
                                readOnly
                                value={searchValue}
                                onChange={utils.handleStringChange(s => setSearchValue(s))}
                                leftIcon="search"
                            />
                            <InputGroup
                                id="inputSearchValue2"
                                placeholder={t('voucher')}
                                value={searchValue2}
                                onChange={utils.handleStringChange(s => setSearchValue2(s))}
                                rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                            />
                            </>}
                            {searchKey === "vendCode" &&
                            <InputGroup
                                id="searchVendor"
                                placeholder={t('vendor')}
                                value={searchVendor}
                                onChange={utils.handleStringChange(s => setSearchVendor(s))}
                                leftIcon="search"
                                rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                            />}
                        </ControlGroup>
                    </FormGroup>
                    {/*<Checkbox className="Col-4-1 Checkbox-LabeledFormGroup" label="Backward" defaultChecked={searchBackward} onChange={utils.handleBooleanChange(v => setSearchBackward(v))} />*/}
                    {/*<Button className="Col-5-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>*/}
                </div>
                <Collapse isOpen={showFilters}>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label={t('from')} labelFor="searchFrom">
                            <InputGroup id="searchFrom" type="date" value={searchFrom} onChange={utils.handleStringChange(s => setSearchFrom(s))} />
                        </FormGroup>
                        <FormGroup className="Col-2-1" label={t('to')} labelFor="searchTo">
                            <InputGroup id="searchTo" type="date" value={searchTo} onChange={utils.handleStringChange(s => setSearchTo(s))} />
                        </FormGroup>
                        <FormGroup className="Col-3-1" label={t('reference')} labelFor="searchReference">
                            <InputGroup id="searchReference" value={searchReference} onChange={utils.handleStringChange(s => setSearchReference(s))} />
                        </FormGroup>
                        <FormGroup className="Col-4-1" label={t('party')} labelFor="searchParty">
                            <InputGroup id="searchParty" value={searchParty} onChange={utils.handleStringChange(s => setSearchParty(s))} />
                        </FormGroup>
                        {/*
                        <div className="Col-4-2 Col-H">
                            <FormGroup label="Limit" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup>
                        </div>
                        */}
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-3" label={t('description')} labelFor="searchDesc">
                            <InputGroup id="searchDesc" value={searchDesc} onChange={utils.handleStringChange(s => setSearchDesc(s))} />
                        </FormGroup>
                    </div>
                </Collapse>
            </form>
            <Tabs onChange={(newTabId) => changeTab(newTabId as string)} selectedTabId={selectedTabId}>
                <Tab id="list" title={t('list')} panel={list} />
                <Tab id="detail" title={t('detail')} panel={detail} />
            </Tabs>
        </>
    );
}

export default PayableMain